import { render } from "./CreateCompanyStepHeader.vue?vue&type=template&id=38db0378"
import script from "./CreateCompanyStepHeader.vue?vue&type=script&lang=js"
export * from "./CreateCompanyStepHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__